import VideoCard from '@/components/base/VideoCard';
import { getFeaturedVideos, getHotVideos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const featured = getFeaturedVideos();
  const hot = getHotVideos().filter((v) => !featured.find((f) => f.id === v.id));

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">精选推荐</h2>
              <p className="text-sm text-foreground-500 mt-1">编辑精心挑选的高分佳作</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
            {featured.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">热门排行</h2>
              <p className="text-sm text-foreground-500 mt-1">全网热播榜单</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
            {hot.slice(0, 4).map((video, index) => (
              <div key={video.id} className="relative">
                <div className="absolute top-0 left-2 z-10 w-7 h-7 flex items-center justify-center rounded-b-lg bg-primary-500 text-white text-xs font-bold">
                  {index + 1}
                </div>
                <VideoCard video={video} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}